import React from 'react'

import { ThemeProvider } from '@leshen/ui'
import 'typeface-montserrat'
import GlobalStyles from './CustomStyles/GlobalStyles'

const Wrapper = ({ children, customTheme }) => (
  <ThemeProvider theme={customTheme}>
    <GlobalStyles />
    {children}
  </ThemeProvider>
)

export default Wrapper
